import { ReactNode } from 'react';
import { Form } from 'semantic-ui-react';
import './styles.scss';

export default function WorksheetForm({ children, isInner, isQuote }: { children: ReactNode, isInner?: true, isQuote?: boolean }) {
  const className = [
    'worksheet-form',
    isInner && 'worksheet-form--inner',
    isQuote && 'worksheet-form--quote'
  ].filter(Boolean).join(' ');

  return (
    <Form className={className}>
      {children}
    </Form>
  );
}
